import { render, staticRenderFns } from "./OrgSaasRevenueDashboard.vue?vue&type=template&id=453670f0"
import script from "./OrgSaasRevenueDashboard.vue?vue&type=script&lang=js"
export * from "./OrgSaasRevenueDashboard.vue?vue&type=script&lang=js"
import style0 from "./OrgSaasRevenueDashboard.vue?vue&type=style&index=0&id=453670f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports